export const OLD_CLI_WARNING_CUTOFF = 1612166400000; // Feb 1 2021 00:00:00 PST
export const YANKED_SDK_VERSION = '0.24.0';
